import { Typography, Select, Grid } from '@ts/storybook';
import { cloneDeep } from 'lodash';
import { CLocation } from '@ts/ui-models';
import { WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

interface IKPIOperationEventFilterInputProps {
  value: {
    eventTypeId: string;
    eventType: {
      id: string;
      name: string;
      customId: string;
    };
    parameter: {
      type: string | null;
      value: string | null;
      locationID: string | null;
    };
  };
  label: string;
  onChangeData: any;
  disabled: boolean;
  withoutParameters?: boolean;
}

const KPIOperationEventFilterInput = (props: IKPIOperationEventFilterInputProps) => {
  const { eventTypeId, parameter = { type: null, value: null, locationID: null } } = (props.value || {}) as any;
  //#region Functions

  //#endregion

  //#region Handlers
  const handleChangeEventType = et => {
    // changed selected event type
    const eventTypeId = et ? et.getID() : null;
    // Small hack to prevent paranoid to show the user has changed the data
    // while it hasnt. Only change it when eventTypeId changes
    if (eventTypeId === (props.value?.eventTypeId || null)) return;
    const newData = { ...props.value };
    newData.eventTypeId = eventTypeId;
    props.onChangeData(newData);
  };

  const handleChangeParamType = value => {
    let newData = cloneDeep(props.value);
    newData.parameter.type = value;
    if (value === 'null') {
      newData.parameter.type = null;
      newData.parameter.value = null;
      newData.parameter.locationID = null;
    }
    props.onChangeData(newData);
  };

  const onChangeGeometry = entity => {
    let newData = cloneDeep(props.value);
    let id = entity ? new CLocation(entity).getGeometry().getID() : null;

    if (!id) {
      newData.parameter.type = null;
    }
    newData.parameter.value = id;
    newData.parameter.locationID = entity?.getID() ?? null;

    props.onChangeData(newData);
  };

  //#endregion

  //#region Render
  const renderParamValue = () => {
    return (
      <WrapperEntitySelector
        label={'Location'}
        searchComponent={generateSearchEntitySelector('location')}
        value={parameter.locationID}
        onChangeEntity={onChangeGeometry}
        isReadOnly={props.disabled}
      />
    );
  };
  //#endregion

  return (
    <Grid container size={12} spacing={2}>
      <Grid size={{ xs: 12, md: 'grow' }}>
        <WrapperEntitySelector
          label={props.label}
          searchComponent={generateSearchEntitySelector('eventType')}
          value={eventTypeId}
          onChangeEntity={handleChangeEventType}
          isReadOnly={props.disabled}
        />
      </Grid>
      {props.withoutParameters ? null : (
        <>
          <Grid container size={'auto'} alignItems="center">
            <Typography text="when parameter" />
          </Grid>
          <Grid size={'grow'}>
            <Select
              value={parameter.type ?? 'null'}
              onChange={handleChangeParamType}
              options={[
                {
                  label: 'No value',
                  value: 'null',
                },
                {
                  label: 'Location',
                  value: 'geometry',
                },
              ]}
              isReadOnly={props.disabled || !props.value.eventTypeId}
            />
          </Grid>
          {parameter.type && (
            <>
              <Grid container size={'auto'} alignItems="center">
                <Typography text="is" />
              </Grid>
              <Grid size={{ xs: 12, md: 'grow' }}>{renderParamValue()}</Grid>
            </>
          )}
        </>
      )}
    </Grid>
  );
};

export default KPIOperationEventFilterInput;
